import {Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild} from '@angular/core';
import {isPlatformBrowser, NgClass} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [
    NgClass,
    RouterLink
  ],
  styleUrls: ['./footer.component.less']
})
export class FooterComponent {
  @ViewChild('intro') intro!: ElementRef;
  show: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @HostListener('document:scroll')
  onViewportScroll() {
    if (!isPlatformBrowser(this.platformId) || !this.intro) { return; }
    const windowHeight = window.innerHeight;
    const boundingRectFive = this.intro.nativeElement.getBoundingClientRect();

    if (boundingRectFive.top <= windowHeight - 100) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
